import branchManagementItemsComponent from './items.component';
import PrintModule from './print';
import './items.scss';

let branchManagementItemsModule = angular.module('branchManagementItemHistoryHolds', [PrintModule])
  .component('branchManagementItemHistoryHolds', branchManagementItemsComponent)
  .name;

export default branchManagementItemsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/items/index.js